import React from 'react';
import { CardStyleds } from './index.styled';

const CardStyled: React.FC = ({ children }) => {
  return <CardStyleds> {children} </CardStyleds>;
};

export default CardStyled;
